"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultIntlText = exports.announcementTypes = exports.announcementTypeIdToIntlText = void 0;
const announcementTypes = exports.announcementTypes = {
  correction: 'message-type/correction',
  report: 'message-type/report',
  global: 'message-type/global',
  finalizedPrice: 'message-type/finalized-price'
};
const announcementTypeIdToIntlText = exports.announcementTypeIdToIntlText = {
  [announcementTypes.correction]: 'Announcements.Type.Correction',
  [announcementTypes.report]: 'Announcements.Type.Report',
  [announcementTypes.global]: 'Announcements.Type.Global',
  [announcementTypes.finalizedPrice]: 'Announcements.Type.FinalizedPrice'
};
const defaultIntlText = exports.defaultIntlText = announcementTypeIdToIntlText[announcementTypes.global];